// Libs
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { Wrapper } from 'components';
import { selectProfile } from 'screens/Login/selectors';
import { selectSelectedSubModuleId } from 'components/Modules/selectors';
import { ModalBuilder } from 'core/ModalBuilder';
// Illustrations
import { SuccessFactorsIllustration } from 'components/Illustrations';
// Utils
import KEYWORDS from '../keywords';
import DisplayBuilderConfig from './display.config';
// Selectors
import {
	selectElementKey,
	selectScreenKey,
	selectDatasourceData,
	selectDatasourceStatus,
	selectIsFetchingDisplay,
	selectSelectedDataFilterLastRowId,
	selectDatasourceFields,
	selectDatasourcePaging,
	selectDatasourceSingleData,
	selectSelectedDataFilterId,
	selectSelectedOrderTargetFilterId,
	selectIsDatasourcePipelineLoading,
} from '../selectors';
// Components
import { ScreenBuilder } from '../ScreenBuilder';
import { ToolbarBuilder } from '../ToolbarBuilder';
import { ElementViewBuilder } from '../ElementViewBuilder';
import { WarehouseSeriesControlProvider } from '../ScreenBuilder/screens/WarehouseSeriesControlScreen/WarehouseSeriesControlContext';

const { ROUTES } = KEYWORDS;
const customDisplays = DisplayBuilderConfig.getAuthorizedDisplayReactNodes();

export const Switcher = ({
	isMobile,
	elementKey,
	screenKey,
	selectedSubModuleId,
	isFetchingDisplay,
	isDatasourcePipelineLoading,
	dataFilterLastRowId,
	datasourceStatus,
	datasourcePaging,
	datasourceFields,
	datasource,
	datasourceSingleData,
	profile,
	onVisibleDatasourceChange,
}) => (
	<Switch>
		{Object.keys(customDisplays).map(path => {
			const CustomDisplay = customDisplays[path];
			if (!CustomDisplay) return null;
			return (
				<Route
					exact
					key={path}
					path={path}
					children={<CustomDisplay isMobile={isMobile} profile={profile} />}
				/>
			);
		})}
		<Route
			exact
			path={ROUTES.FEED_MODULE_ELEMENT.PATH}
			children={
				<ElementViewBuilder
					shortcutPath={true}
					isMobile={isMobile}
					elementKey={elementKey}
				/>
			}
		/>
		<Route
			exact
			path={ROUTES.FEED_MODULE.PATH}
			children={
				<>
					<ScreenBuilder
						key={selectedSubModuleId}
						elementKey={elementKey}
						screenKey={screenKey}
						isMobile={isMobile}
						selectedSubModuleId={selectedSubModuleId}
						isFetchingDisplay={isFetchingDisplay}
						isDatasourcePipelineLoading={isDatasourcePipelineLoading}
						dataFilterLastRowId={dataFilterLastRowId}
						datasourceStatus={datasourceStatus}
						datasourcePaging={datasourcePaging}
						datasourceFields={datasourceFields}
						datasource={datasource}
						datasourceSingleData={datasourceSingleData}
						profile={profile}
						onVisibleDatasourceChange={onVisibleDatasourceChange}
					/>
					<ElementViewBuilder isMobile={isMobile} elementKey={elementKey} />
				</>
			}
		/>
		<Route
			path={ROUTES.FEED.PATH}
			children={
				<SuccessFactorsIllustration
					className='animated backInRight'
					title='Bienvenido a Synapse Feed'
					width={isMobile ? '200px' : '400px'}
					fontSize='2em'
				/>
			}
		/>
	</Switch>
);

const DisplayBuilder = React.memo(
	({
		// Props
		menuIsOpen,
		isMobile,
		// State
		elementKey,
		screenKey,
		selectedSubModuleId,
		isFetchingDisplay,
		isDatasourcePipelineLoading,
		dataFilterLastRowId,
		datasourceStatus,
		datasourcePaging,
		datasourceFields,
		datasourceData,
		datasourceSingleData,
		selectedDataFilterId,
		selectedOrderTargetFilterId,
		profile,
	}) => {
		const [visibleDatasource, setVisibleDatasource] =
			React.useState(datasourceData);

		const seriesControlResetKey = `${selectedDataFilterId || ''}:${
			selectedOrderTargetFilterId || ''
		}`;

		return (
			<WarehouseSeriesControlProvider resetKey={seriesControlResetKey}>
				<Wrapper
					style={isMobile ? { gridColumn: '1 / -1' } : undefined}
					padding='0'
					flexDirection='column'
					width='100%'
					overflow='hidden'
				>
					<ToolbarBuilder
						menuIsOpen={menuIsOpen}
						screenKey={screenKey}
						elementKey={elementKey}
						isMobile={isMobile}
						datasource={visibleDatasource}
						datasourceStatus={datasourceStatus}
						datasourceSingleData={datasourceSingleData}
					/>
					<Switcher
						isMobile={isMobile}
						elementKey={elementKey}
						screenKey={screenKey}
						selectedSubModuleId={selectedSubModuleId}
						isFetchingDisplay={isFetchingDisplay}
						isDatasourcePipelineLoading={isDatasourcePipelineLoading}
						dataFilterLastRowId={dataFilterLastRowId}
						datasourceStatus={datasourceStatus}
						datasourcePaging={datasourcePaging}
						datasourceFields={datasourceFields}
						datasource={datasourceData}
						datasourceSingleData={datasourceSingleData}
						profile={profile}
						onVisibleDatasourceChange={setVisibleDatasource}
					/>
					<ModalBuilder />
				</Wrapper>
			</WarehouseSeriesControlProvider>
		);
	},
);

const mapStateToProps = state => ({
	elementKey: selectElementKey(state),
	screenKey: selectScreenKey(state),
	selectedSubModuleId: selectSelectedSubModuleId(state),
	isFetchingDisplay: selectIsFetchingDisplay(state),
	isDatasourcePipelineLoading: selectIsDatasourcePipelineLoading(state),
	dataFilterLastRowId: selectSelectedDataFilterLastRowId(state),
	datasourceStatus: selectDatasourceStatus(state),
	datasourcePaging: selectDatasourcePaging(state),
	datasourceFields: selectDatasourceFields(state),
	datasourceData: selectDatasourceData(state),
	datasourceSingleData: selectDatasourceSingleData(state),
	selectedDataFilterId: selectSelectedDataFilterId(state),
	selectedOrderTargetFilterId: selectSelectedOrderTargetFilterId(state),
	profile: selectProfile(state),
});

export default connect(mapStateToProps, null)(DisplayBuilder);
